/**
 * 输入焦点
 */
export default {
  bind(el) {
    el.focus()
  }
}
